import { css } from '@linaria/core';
import theme from '../../../theme';

export const variants = {
  show: css``,
  left: css``,
  right: css``,
  vertical: css``,
  horizontal: css``,
  top: css``,
  bottom: css``,
  visible: css``,
};
export const components = {
  scrollableIcon: css``,
  content: css``,
  fade: css``,
};

export const scrollable = css`
  display: flex;
  align-items: center;
  position: relative;
  opacity: 0;
  transition: opacity 0.25s ease-in;
  &.${variants.visible} {
    opacity: 1;
  }

  --scrollable-gradient-from: rgba(255, 255, 255, 0);
  --scrollable-gradient-to: #fff;
  --scrollable-color: ${theme.colors.neutral['99']};
  --scrollable-hover-bg: ${theme.colors.primary['10']};
  &:has(.${components.scrollableIcon}) {
    @media screen and (width > ${theme.sizes.screens.md}) {
      padding-left: 42px;
      padding-right: 42px;
    }
  }
  & .${components.scrollableIcon} {
    cursor: not-allowed;
    color: ${theme.colors.neutral['50']};
    flex-shrink: 0;
    padding: 0 12px;
    width: 42px;
    position: absolute;
    display: none;
    top: 0;
    bottom: 0;
    padding-bottom: var(--scrollable-icon-offset);
    &.right {
      right: 0;
    }
    &.left {
      left: 0;
    }
    @media screen and (width > ${theme.sizes.screens.md}) {
      display: flex;
    }

    &.${variants.show} {
      cursor: pointer;
      color: var(--scrollable-color);
    }
  }

  &.${variants.vertical} {
    align-items: stretch;
    justify-content: start;
    & .${components.content} {
      flex-direction: column;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }

  &.${variants.horizontal} .${components.content} {
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  & .${components.content} {
    flex-grow: 1;
    position: relative;
    scroll-behavior: smooth;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    min-width: 100%;
  }

  & .${components.fade} {
    display: none;
    position: sticky;
    opacity: 0;
    pointer-events: none;
    z-index: 1;

    &::after {
      content: '';
      display: block;
      position: absolute;
    }

    &.${variants.horizontal} {
      width: 0;
      top: 0;
      bottom: 0;
      &::after {
        width: 40px;
        top: 0;
        bottom: 0;
      }
    }

    &.${variants.vertical} {
      height: 0;
      left: 0;
      right: 0;
      &::after {
        height: 40px;
        left: 0;
        right: 0;
      }
    }

    &.${variants.show} {
      opacity: 1;
      transition: opacity 0.25s linear;
    }

    &.${variants.left} {
      left: -1px;

      &::after {
        left: 0;
        background-image: linear-gradient(to left, var(--scrollable-gradient-from), var(--scrollable-gradient-to));
      }
    }

    &.${variants.right} {
      right: -1px;

      &::after {
        right: 0;
        background-image: linear-gradient(to right, var(--scrollable-gradient-from), var(--scrollable-gradient-to));
      }
    }

    &.${variants.top} {
      top: -1px;

      &::after {
        top: 0;
        background-image: linear-gradient(to top, var(--scrollable-gradient-from), var(--scrollable-gradient-to));
      }
    }

    &.${variants.bottom} {
      bottom: -1px;

      &::after {
        bottom: 0;
        background-image: linear-gradient(to bottom, var(--scrollable-gradient-from), var(--scrollable-gradient-to));
      }
    }
  }
`;
